
import {makeApiServerRequest} from "../../stores/serverConnection/makeApiServerRequest";
import {WsServerConnection} from "../../stores/serverConnection/wsServerConnection";

import {METRIC_ACTION} from './common';


export const registerQuizVisit = (wsServerConnection: WsServerConnection) => {
    return makeApiServerRequest(wsServerConnection, `m/${METRIC_ACTION.QUIZ_VISIT}`);
}

export const registerQuizCreate = (wsServerConnection: WsServerConnection) => {
    return makeApiServerRequest(wsServerConnection, `m/${METRIC_ACTION.QUIZ_CREATE}`);
}

export const registerSearchRequest = (wsServerConnection: WsServerConnection) => {
    return makeApiServerRequest(wsServerConnection, `m/${METRIC_ACTION.SEARCH_EXECUTE}`);
}

export const registerLimitBreach = (wsServerConnection: WsServerConnection, limitType: 'location' | 'user' | 'storage' = 'location') => {
    return makeApiServerRequest(wsServerConnection, `m/${METRIC_ACTION.LIMIT_BREACH}`, { limitType });
}
